import { Box, Flex, Image, Text } from "@chakra-ui/core";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { navLInks } from "../lib/utils/mock";
import { NavItem } from "./NavItem";
import logoImg from "../assets/images/green-logo.png";
import logo2 from "../assets/images/logo-2.png";
import useAuth from "../context/AuthContext";
import { logout } from "../api/auth.service";
import { useWindowDimensions } from "../lib/utils/hooks";
import { MobileNav } from "./MobileNav";
import styles from "./Hero.module.css";
export const Navbar = (props) => {
  const [show, setShow] = React.useState(false);
  const handleToggle = () => setShow(!show);
  const { width } = useWindowDimensions();

  const isMobile = width <= 1000;
  // const isTablet = width > 900 && width <= 1200;

  const history = useHistory();

  const {
    state: { isAuthenticated },
    dispatch,
  } = useAuth();

  const logoutUser = () => {
    dispatch({ type: "LOGOUT" });
    logout();
    history.push("/");
  };

  const isRegisterLink = (link) => {
    if (isAuthenticated && link === "Register") {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      bg="white"
      color="#000"
      position="fixed"
      top="0"
      left="0"
      padding={["5px 30px", "5px 30px", "0px 20px"]}
      w={["100vw", "100vw", "100vw", "100%"]}
      zIndex="320"
      borderBottom="2px solid #eee"
      {...props}
    >
      <Link to="/">
        <Flex align="center">
          <Box
            // w={["100px", "205px"]}s
            className={styles.LogoImage}
            ml={["0", "0", "6"]}
          >
            <Image src={logoImg} objectFit="contain" />
          </Box>
          {/* <Box className={styles.LogoImage2} ml={["0", "0"]} mb="2">
            <Image src={logo2} objectFit="contain" />
          </Box> */}
        </Flex>
      </Link>

      <Box className={styles.NavMenu} onClick={handleToggle}>
        <svg
          fill="black"
          width="20px"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </Box>

      <Box
        display={{
          base: show ? "flex" : "none",
          md: show ? "flex" : "none",
          lg: "flex",
        }}
        width={{ base: "full", md: "full", lg: "auto" }}
        alignItems={["start", "start", "center"]}
        alignSelf={["flex-end", "flex-end", "center"]}
        flex={["auto", "auto", "auto", "1"]}
        justifyContent={["flex-end", "flex-end", "center"]}
        justifySelf={["flex-end", "flex-end", "center"]}
        flexDirection={["column", "column", "row"]}
        // border="2px solid red"
        mr={["0", "0"]}
      >
        {navLInks.map((navLink, index) => {
          return isRegisterLink(navLink.title) ? null : isMobile ? (
            <MobileNav menu={navLink} key={index} />
          ) : (
            <NavItem
              title={navLink.title}
              links={navLink.dropdownLinks}
              key={navLink.title}
              path={navLink.path}
              sublinks={navLink.dropdownLinks.filter(
                (link) => link.dropdownLinks !== 0
              )}
            />
          );
        })}
      </Box>
      {isAuthenticated && (
        <Box
          display={{
            base: show ? "flex" : "none",
            md: show ? "flex" : "none",
            lg: "flex",
          }}
        >
          <Link to="/dashboard">
            <Text
              ml={["2", "2", "auto"]}
              my="4"
              fontWeight="500"
              fontFamily="Museo Sans"
              fontSize={["lg", "lg", "16px"]}
              alignSelf={["auto", "auto", "end"]}
              justifySelf={["auto", "auto", "end"]}
            >
              Dashboard
            </Text>
          </Link>
        </Box>
      )}
    </Flex>
  );
};
